export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	ADMINS = 'admins',

	PRODUCT_MODULES = 'product-modules',
	PRODUCT_MODULES_CATEGORIES = 'product-module-categories',
	PROJECTS = 'projects',
	LANDSCAPE_MODUELS = 'landscape-modules',
	MATERIALS = 'materials',
	MODELS = 'models',
	ROLES = 'roles',
	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',
	PRESETS = 'presets',

	CONTENT = 'content',
}
